export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'usedBy', label: '业务员', minWidth: '80'},
    {prop: 'deptName', label: '所属岗位', minWidth: '80'},
    {prop: 'groupName', label: '所属组', minWidth: '80'},
    {prop: 'customerCount', label: '客户数', minWidth: '80', sortable: 'custom'},
    {prop: 'callCount', label: '通话次数', minWidth: '80', sortable: 'custom'},
    {prop: 'callRate', label: '接通率', minWidth: '80'},
    {prop: 'level', label: '评级', minWidth: '60', sortable: 'custom'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
